import React from 'react'
import { Helmet } from 'react-helmet'

import '../css/Team.css'

import Abebe from '../assets/img/abebe.jpg'
import Addis from '../assets/img/addis.jpg'
import Belay from '../assets/img/belay.jpg'
import Berhe from '../assets/img/berhe.jpg'
import Etana from '../assets/img/tent.jpg'
import Fikre from '../assets/img/fikre.jpg'
import Rahel from '../assets/img/rahel.jpg'
import Worku from '../assets/img/worku.jpg'
import Yilma from '../assets/img/yilma.jpg'
import Melaku from '../assets/img/melaku.jpg'
import Selamu from '../assets/img/selamu.jpg'
import Tefera from '../assets/img/tefera.jpg'
import Teferi from '../assets/img/teferi.jpg'
import Zewdie from '../assets/img/zewdie.jpg'
import Bisewer from '../assets/img/bisewer.jpg'
import Sileshi from '../assets/img/sileshi.jpg'
import Solomon from '../assets/img/solomon.jpg'
import Tadesse from '../assets/img/tadesse.jpg'
import Zelalem from '../assets/img/zelalem.jpg'
import Tewodros from '../assets/img/tewodros.jpg'
import Yeshitla from '../assets/img/yeshitla.jpg'
import Yohannes from '../assets/img/yohannes.jpg'

export default function Team() {
  return (
    <div id="team">
      <Helmet>
        <title>Team - Enoho Fikir</title>
      </Helmet>

      <h1>Meet Our Team</h1>

      <div id="team-list">
        <div className="member-card">
          <img src={ Yohannes } />
          <h3>Captain Sishah Yohannes</h3>
          <span>chong737@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Sileshi } />
          <h3>Captain Haimanot Sileshi</h3>
          <span>haimysb@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Teferi } />
          <h3>Ethiopia Teferi</h3>
          <span>babyteferi@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Melaku } />
          <h3>Captain Zinnahbizu Melaku</h3>
          <span>zinnahbizumelaku@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Yeshitla } />
          <h3>Esete Yeshitla</h3>
          <span>esetyeshitla@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Worku } />
          <h3>Mahlet Worku</h3>
          <span>mahlyared@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Addis } />
          <h3>Captain Samson Addis</h3>
          <span>samson_haddis@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Selamu } />
          <h3>Menna Selamu</h3>
          <span>mennaselamu@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Yilma } />
          <h3>Captain Michael Yilma</h3>
          <span>mickyyilma@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Tefera } />
          <h3>Captain Yared Tefera</h3>
          <span>yaredmahl@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Etana } />
          <h3>Captain Challa Etana</h3>
          <span>challaetana@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Tefera } />
          <h3>Captain Elias Tefera</h3>
          <span>eliastf5921@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Tewodros } />
          <h3>Engineer Tewodros w/Amlak</h3>
          <span>teddyamlak@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Zewdie } />
          <h3>General Mehari Zewdie</h3>
          <span>meharizewdie@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Abebe } />
          <h3>Ato Girum Abebe</h3>
          <span>girumadd@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Rahel } />
          <h3>Rahel G/Mariam</h3>
          <span>rahelgebremariam@vsoint.org</span>
        </div>

        <div className="member-card">
          <img src={ Fikre } />
          <h3>Yeshimebet Fikre</h3>
          <span>mimifikre1994@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Belay } />
          <h3>Sara Belay</h3>
          <span>meharizewdie@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Berhe } />
          <h3>Meharawit Berhe</h3>
          <span>nanimerhawit1@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Tadesse } />
          <h3>Tsigereda Tadesse</h3>
          <span>girumadd@gmail.com</span>
        </div>

        <div className="member-card">
          <img src={ Bisewer } />
          <h3>Metasebia Bisewer</h3>
          <span>eliastf5921@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Zelalem } />
          <h3>Netsanet Zelalem</h3>
          <span>samson_haddis@yahoo.com</span>
        </div>

        <div className="member-card">
          <img src={ Solomon } />
          <h3>Mahder Solomon</h3>
          <span>didi-solomon@yahoo.com</span>
        </div>
      </div>
    </div>
  )
}